import types from '../mutation-types';
import LeadsAPI from '../../api/leads';

export const state = {
  records: [],
  meta: { count: 0, currentPage: 1 },
  uiFlags: {
    isFetching: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getLeads(_state) {
    return _state.records;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, params = {}) => {
    commit(types.SET_LEAD_UI_FLAG, { isFetching: true });
    try {
      const { data } = await LeadsAPI.get(params);
      commit(types.SET_LEADS, data.payload);
      commit(types.SET_LEADS_META, data.meta);
    } finally {
      commit(types.SET_LEAD_UI_FLAG, { isFetching: false });
    }
  },

  update: async ({ commit }, { id, ...lead }) => {
    commit(types.SET_LEAD_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await LeadsAPI.update(id, { lead });
      commit(types.EDIT_LEAD, data);
    } finally {
      commit(types.SET_LEAD_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_LEAD_UI_FLAG, { isDeleting: true });
    try {
      await LeadsAPI.delete(id);
      commit(types.DELETE_LEAD, id);
    } finally {
      commit(types.SET_LEAD_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_LEAD_UI_FLAG](_state, uiFlags) {
    _state.uiFlags = { ..._state.uiFlags, ...uiFlags };
  },
  [types.SET_LEADS](_state, records) {
    _state.records = records;
  },
  [types.SET_LEADS_META](_state, { count, current_page: currentPage }) {
    _state.meta = { count, currentPage: Number(currentPage) };
  },
  [types.EDIT_LEAD](_state, lead) {
    const index = _state.records.findIndex(record => record.id === lead.id);
    if (index > -1) _state.records.splice(index, 1, lead);
  },
  [types.DELETE_LEAD](_state, id) {
    _state.records = _state.records.filter(record => record.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
